import { ubtModuleExposeNew } from '../utils/ubt';

export const rightMonitorReport = <T> (
  monitorEvent: string,
  params?: T | null,
):void => {
  try {
    ubtModuleExposeNew(
      '臻有钱_提现申请页',
      'finance_loan_rights_monitor',
      {
        event: monitorEvent,
        response: (params && JSON.stringify(params)) || '',
      },
    );
  } catch (err) {
    //
  }
};
